<template>
  <header class="app-banner">
    <div class="app-banner__content">
      <div class="app-banner__left">
        <img :src="require('@/assets/img/kiey-icon.svg')" alt="Kiey" class="app-banner__icon"/>
        <span class="app-banner__text">Download the app <span class="app-banner__now">now!!</span></span>
      </div>
      <div class="app-banner__stores">
        <a :href="this.$store.getters['Authenticate/getAppleStoreUrl']" target="_blank">
          <img :src="require('@/assets/img/app-store-simple-white.svg')" alt="App Store" class="app-banner__badge"/>
        </a>
        <a :href="this.$store.getters['Authenticate/getGooglePlayUrl']" target="_blank">
          <img :src="require('@/assets/img/google-play-simple-white.svg')" alt="Google Play" class="app-banner__badge"/>
        </a>
        <router-link to="/download">
          <img :src="require('@/assets/img/desktop-app-white.svg')" alt="Download for Desktop" class="app-banner__badge"/>
        </router-link>
      </div>
      <button class="app-banner__close" @click="closeBanner">
        <img :src="require('@/assets/img/close-banner.svg')" alt="Close"/>
      </button>
    </div>
  </header>
</template>

<script>
export default {
  name: "navApp",
  methods: {
    closeBanner() {
      this.$store.dispatch('Banner/hide');
    }
  }
};
</script>

<style scoped>
.app-banner {
  width: 100%;
  position: relative;
}

.app-banner__content {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1426px;
  margin: 0 auto;
  padding: 14px 48px 14px 20px;
  gap: 24px;
}

.app-banner__left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.app-banner__icon {
  width: 36px;
  height: 36px;
}

.app-banner__text {
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  white-space: nowrap;
}

.app-banner__now {
  color: #29abe2;
}

.app-banner__stores {
  display: flex;
  align-items: center;
  gap: 12px;
}

.app-banner__badge {
  height: 36px;
  display: block;
}

.app-banner__close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.app-banner__close img {
  width: 18px;
  height: 18px;
}

/* Tablet */
@media (max-width: 900px) {
  .app-banner__content {
    padding: 10px 44px 10px 16px;
    gap: 12px;
  }

  .app-banner__icon {
    width: 28px;
    height: 28px;
  }

  .app-banner__text {
    font-size: 13px;
  }

  .app-banner__badge {
    height: 30px;
  }

  .app-banner__close {
    right: 12px;
  }
}

/* Mobile */
@media (max-width: 600px) {
  .app-banner__content {
    padding: 8px 40px 8px 12px;
    gap: 8px;
  }

  .app-banner__text {
    display: none;
  }

  .app-banner__icon {
    width: 24px;
    height: 24px;
  }

  .app-banner__badge {
    height: 26px;
  }

  .app-banner__stores {
    gap: 8px;
  }

  .app-banner__close {
    right: 8px;
  }
}
</style>
